import React, { ReactElement } from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import _ from "lodash";

import "./ProfileLink.scss";

import {
  ProfileTabContent,
  ProfileTabDropdown,
} from "../profileTab/ProfileTab";

interface ProfileLinkProps {
  to: string;
  title: string;
  menu?: any;
  description?: ReactElement;
  type?: string;
  isActive?: boolean;
}

export const ProfileLink = ({
  to,
  menu,
  title,
  description,
  type,
  isActive,
}: ProfileLinkProps) => {
  const hasMenu = !_.isEmpty(menu);

  return (
    <div
      className={classnames("profile-link", {
        "profile-link--has-menu": hasMenu,
        "profile-link--active": isActive,
      })}
    >
      <NavLink
        to={to}
        className={({ isActive }) =>
          classnames("profile-link__link", { "profile-tab--active": isActive })
        }
      >
        <ProfileTabContent
          type={type}
          title={title}
          description={description}
        />
      </NavLink>

      {hasMenu && (
        <div className="profile-link__menu">
          <ProfileTabDropdown menu={menu} profileName={title} />
        </div>
      )}
    </div>
  );
};
